function shareEscapeHtml(str) {
    return str.replace('"', '\\"');
}

import { getBrowerList } from '@utils/browser';
import jsonp from 'jsonp';

const browerlist = getBrowerList();

// 自定义二次分享
/*
 * init    传入参数
 * title - 必须是数组，如果策划文案朋友圈和好友只有一条，那么只需传入一个数据的数组[xxx]
 *         如果朋友圈跟好友有区分不同文案，则传入一个两条数据的数组[xxx,xxx]，第一条为好友，第二条为朋友圈
 * showPic - 为分享图片, 微信建议最大200x200
 * desc - 分享描述文案
 *
 * 微信朋友圈只读取title，微信好友读取title和des
 * 新浪微博一般分享都会拿新浪自己的图片
 * （此方法已废弃）QQ分享最好是在页面body上面写上一个div隐藏标签，里面带img标签，这样QQ会优先获取你的第一张img，如果是通过JavaScript的createElement创建，则无效
 */
function init(json) {
    var _title = json.title;
    var _sharePic = json.showPic;
    var _desc = shareEscapeHtml(json.desc);

    // 处理如果微信只有一个title，那么好友和朋友圈title都使用同一个
    if (browerlist.isWx && _title.length == 1) {
        _title = [shareEscapeHtml(_title[0]), shareEscapeHtml(_title[0])];
    } else if (browerlist.isWx && _title.length > 1) {
        _title[0] = shareEscapeHtml(_title[0]);
        _title[1] = shareEscapeHtml(_title[1]);
    }

    var script = document.createElement('script');
    script.src = '//cc.res.netease.com/activity/common/js/shareapi.min.js';
    script.onload = function() {
        (browerlist.QQ || browerlist.isWx) && editWeixinShare(_title, _desc, _sharePic);
        browerlist.isYixin && editYixinShare(_title, _desc, _sharePic);
        browerlist.isWeibo && editWeiboShare(_title, _desc, _sharePic);
    };
    document.body.appendChild(script);
}

function editWeixinShare(tit, des, pic) {
    var url = location.href.split('#')[0];
    jsonp(
        '//mzone.cc.163.com/wxpay/cc/jsticket?url=' + encodeURIComponent(url),
        {},
        (err, data) => {
            if (err) {
                console.error(err.message);
            } else {
                changeWeixinShareContent(data);
            }
        }
    );

    function changeWeixinShareContent(wx_conf) {
        setShareInfo({
            title: tit,
            summary: des,
            pic: pic,
            url: url,
            WXconfig: {
                swapTitleInWX: true,
                appId: wx_conf.appid,
                timestamp: wx_conf.timestamp,
                nonceStr: wx_conf.nonce_str,
                signature: wx_conf.signature
            }
        });
    }
}

// 易信二次分享
function editYixinShare(tit, des, pic) {
    var head = document.getElementsByTagName('head')[0];
    var metaImg = document.createElement('meta');
    var metaDesc = document.createElement('meta');
    document.title = tit[0];
    metaImg.name = 'yixin-share-image';
    metaImg.content = pic;
    metaDesc.name = 'yixin-share-desc';
    metaDesc.content = des;
    head.appendChild(metaImg);
    head.appendChild(metaDesc);
}
// 新浪微博二次分享
function editWeiboShare(tit, des, pic) {
    document.title = tit[0];
    var meta = document.getElementsByTagName('meta');
    for (var i in meta) {
        if (typeof meta[i].name != 'undefined' && meta[i].name.toLowerCase() == 'description') {
            meta[i].content = des;
        }
    }
}

export default init;
